import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import '@starwardforge/web-kit/styles.css';
import '@workspace/silk-ui/style.css';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
